/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { OrderBy } from '../../pipes/order-by.pipe';
import { XdaStringsService } from '../../services/xda-strings.service';
import { XrxControlBaseComponent } from './xrx-control-base.component';
import { OptionListOptions, Parameter } from '../../services/workflow.service';

@Component({
  selector: 'xrx-popover-conversion',
  templateUrl: './xrx-popover-conversion.component.html',
  styleUrls: ['./xrx-popover-conversion.component.less'],
  providers: [
    {
      provide: XrxControlBaseComponent,
      useExisting: XrxPopoverConversionComponent,
    },
  ],
  standalone: false,
})
export class XrxPopoverConversionComponent extends XrxControlBaseComponent implements OnInit {
  @Input() param: Parameter;
  @Input() valuePosition = 'left';
  @Input() checkSame = true;
  @Input() error: string;
  @Output() change = new EventEmitter<any>();
  @Output() change2 = new EventEmitter<any>();
  @Output() validation = new EventEmitter<boolean>();

  toLanguageTouched = false;
  orderByPipe: OrderBy<OptionListOptions>;

  constructor(private _xdaStringsService: XdaStringsService) {
    super();
    this.orderByPipe = new OrderBy(this._xdaStringsService);
  }

  ngOnInit() {
    this.orderByPipe.transform(this.param.options2, 'asc', 'key');
  }

  /**
   * called by parent component
   */
  validate() {
    this.toLanguageTouched = true;
    this.doValidate(this.param.selectedValue, this.param.selectedValue2);
  }

  doValidate(value: any, value2: any) {
    this.validation.emit(value.value !== value2.value);
  }
}
